import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { onMounted } from "vue";
import RouteLoader from "@/components/shared/RouteLoader.vue";
import { empilharModaisBs5 } from "@/utils/empilharModaisBs5";


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

onMounted(empilharModaisBs5);

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(RouteLoader),
    _createVNode(_component_router_view)
  ], 64))
}
}

})